import React from "react";

import { Flex, Button, LanguageDropdown, AccountDropdown } from "components";
import { CircledBurgerMenu } from "icons";

import { AppLocation } from "../AppLocation";

import "./index.scss";

export interface AppTopbarProps {
  sidebarToggleVisible: boolean;
  onSidebarToggle: () => void;
}

export const AppTopbar: React.FC<AppTopbarProps> = ({ sidebarToggleVisible, onSidebarToggle }) => {
  return (
    <header className="app-topbar">
      <Flex gap="1rem" justify="space-between">
        <Flex gap="1rem" align="center">
          {sidebarToggleVisible && (
            <Button
              style={{ /** Avoid increasing topbar height */ margin: "-1rem" }}
              auto
              light
              color="secondary"
              icon={<CircledBurgerMenu />}
              onClick={onSidebarToggle}
            />
          )}
          <AppLocation />
        </Flex>
        <Flex justify="end" wrap gap="0.4rem">
          <AccountDropdown />
          <LanguageDropdown />
        </Flex>
      </Flex>
    </header>
  );
};
